import { render, staticRenderFns } from "./couponlist.vue?vue&type=template&id=2bf67d52&scoped=true&"
import script from "./couponlist.vue?vue&type=script&lang=js&"
export * from "./couponlist.vue?vue&type=script&lang=js&"
import style0 from "./couponlist.vue?vue&type=style&index=0&id=2bf67d52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf67d52",
  null
  
)

export default component.exports